import { DevicePermissionsEventTypes, } from '@office-start/device-permission-types';
import { PermissionStatus } from '@office-start/metaos-hub-sdk';
// When this inevitably needs to scale, look at the Orange hub:
// https://office.visualstudio.com/ISS/_git/metaos-hub-sdk?path=/apps/orange-web/src/components/NovaProvider/NovaEventHandler.tsx&version=GBmain&_a=contents
export const getConsentNovaEventHandler = (event, hideRequestDialog) => {
    const consentDenyEvent = () => hideRequestDialog(PermissionStatus.Revoked);
    const consentAllowEvent = () => hideRequestDialog(PermissionStatus.Consented);
    return consentDialogEventHandler(event, {
        consentDenyEvent,
        consentAllowEvent,
    });
};
const consentDialogEventHandler = (event, actions) => {
    var _a, _b;
    const novaEvent = event;
    switch (novaEvent.type) {
        case DevicePermissionsEventTypes.denyPermission:
            (_a = actions.consentDenyEvent) === null || _a === void 0 ? void 0 : _a.call(actions);
            break;
        case DevicePermissionsEventTypes.allowPermission:
            (_b = actions.consentAllowEvent) === null || _b === void 0 ? void 0 : _b.call(actions);
            break;
        default:
            throw new Error(`NovaEvent.type was invalid: ${novaEvent.type}`);
    }
};
//# sourceMappingURL=getConsentNovaEventHandler.js.map